const r = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="t2-icon--open-arrow-left-dark-16px" viewBox="0 0 16 15">\r
<title>open arrow left dark 16px</title>\r
<g class="nc-icon-wrapper">\r
<g>\r
<path d="M15 6.5a1 1 0 0 1 0 2H1.071a1 1 0 0 1 0-2H15z"/>\r
<path d="M2.486 7.5l5.793 5.793a1 1 0 0 1-1.415 1.414l-6.5-6.5a1 1 0 0 1 0-1.414l6.5-6.5A1 1 0 0 1 8.28 1.707L2.486 7.5z"/>\r
</g>\r
</g>\r
</svg>\r`;
export {
  r as default
};
